import { HttpResponseData } from '../interfaces/http-response-data.interface';
import { NotificationModel, ODataNotificationModel } from '../models/low-level/notification.model';
import dataToday from './NdpHeaderSet-Todays.json';
import dataUpcoming from './NdpHeaderSet-Upcoming.json';
import dataNew from './NdpHeaderSet-New.json';

export function getTestNotification(frontId: string, qmNum: string, maNum: string): NotificationModel {
    const todaysOdataNotifications = (dataToday as unknown as HttpResponseData<ODataNotificationModel[]>).d.results;
    const upcomingOdataNotifications = (dataUpcoming as unknown as HttpResponseData<ODataNotificationModel[]>).d
        .results;
    const newOdataNotifications = (dataNew as unknown as HttpResponseData<ODataNotificationModel[]>).d.results;
    const allNotifications = [...todaysOdataNotifications, ...upcomingOdataNotifications, ...newOdataNotifications];
    const odataNotification = allNotifications.find(
        (n) => n.FrontId === frontId && n.NotificationNo === qmNum && n.TaskNumber === maNum,
    );

    if (typeof odataNotification === 'undefined') {
        throw new Error(
            `NotificationHelper: getMockNotification: No odata notification found for the frontId ${frontId} and qmNum ${qmNum} and maNum ${maNum}`,
        );
    }

    return new NotificationModel(odataNotification);
}

export function getTestNotifications(): NotificationModel[] {
    const todaysOdataNotifications = (dataToday as unknown as HttpResponseData<ODataNotificationModel[]>).d.results;
    const upcomingOdataNotifications = (dataUpcoming as unknown as HttpResponseData<ODataNotificationModel[]>).d
        .results;
    const newOdataNotifications = (dataNew as unknown as HttpResponseData<ODataNotificationModel[]>).d.results;
    const allNotifications = [...todaysOdataNotifications, ...upcomingOdataNotifications, ...newOdataNotifications];

    return allNotifications.map((notification) => new NotificationModel(notification));
}

export function getTodaysTestNotifications(): NotificationModel[] {
    const todaysOdataNotifications = (dataToday as unknown as HttpResponseData<ODataNotificationModel[]>).d.results;
    return todaysOdataNotifications.map((todaysOdataNotification) => new NotificationModel(todaysOdataNotification));
}

export function getUpcomingTestNotifications(): NotificationModel[] {
    const upcomingOdataNotifications = (dataUpcoming as unknown as HttpResponseData<ODataNotificationModel[]>).d
        .results;
    return upcomingOdataNotifications.map(
        (upcomingOdataNotification) => new NotificationModel(upcomingOdataNotification),
    );
}

export function getNewTestNotifications(): NotificationModel[] {
    const newOdataNotifications = (dataNew as unknown as HttpResponseData<ODataNotificationModel[]>).d.results;
    return newOdataNotifications.map((newOdataNotification) => new NotificationModel(newOdataNotification));
}
